import React from 'react'

import makeStyles from '@material-ui/core/styles/makeStyles'
import { useInput } from 'react-admin'

import { CurrencyInternalInput } from './currencyInternalInput'

const useStyles = makeStyles({
  input: {
    paddingLeft: '36px',
    maxHeight: '48px',
  },
  title: {
    position: 'relative',
    top: '29px',
    left: '20px',
    width: '40px',
    height: '0px',
  },
  content: {
    display: 'inline',
    position: 'relative',
    top: '8px',
    height: '60px',
  },
})

export const CurrencyInput = (props) => {
  const classes = useStyles()
  const {
    input: { name, value },
  } = useInput(props)

  return (
    <div className={classes.content}>
      <CurrencyInternalInput
        name={name}
        value={value}
        {...props}
        InputProps={{
          className: classes.input,
        }}
        onChange={props.onChange}
      />
    </div>
  )
}
